/*
  Heon motion loader (motion team, 2026-09-27). Deferred on every page, about 1 KB.
  Loads the checkout animation (heon-motion-checkout.js, ~20 KB) only when it may be needed: when the cart drawer
  opens, on the cart page, or when a pointer, finger or keyboard focus reaches a Checkout button.
  Checkout never depends on it: without the module the Checkout button submits exactly as before.
*/
(() => {
  const me = document.currentScript;
  const src = me && me.dataset.checkout;
  if (!src || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let asked = false;
  const load = () => {
    if (asked || window.HeonCheckoutMotion) return;
    asked = true;
    const s = document.createElement('script');
    s.src = src; s.async = true;
    s.onerror = () => { asked = false; };
    document.head.appendChild(s);
  };
  document.addEventListener('on:cart-drawer:before-open', load);
  const near = e => { const t = e.target; if (t && t.closest && t.closest('button[name="checkout"]')) load(); };
  for (const type of ['pointerover', 'touchstart', 'focusin']) document.addEventListener(type, near, { passive: true, capture: true });
  if (document.body && document.body.classList.contains('template-cart')) {
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 }); else setTimeout(load, 1200);
  }
})();
